import type { Ride } from '../domain/ride';
import type { UnitSystem } from '../domain/measurement-units';
import { filenamePart } from '../../../renderer/src/download-filename';

export type RouteImageTreatment = 'terra-terrain';

export interface RouteImageRecipe {
  readonly treatment: RouteImageTreatment;
  readonly rotation: number;
  readonly tilt: number;
  readonly terrainHeight: number;
  readonly unitSystem: UnitSystem;
}

export const IMAGE_WIDTH = 2400;
export const IMAGE_HEIGHT = 1800;
export const IMAGE_LAYOUT = { width: 800, height: 600, x: 24, y: 78, sceneWidth: 752, sceneHeight: 414 } as const;
export const TREATMENTS = [
  { id: 'terra-terrain', label: 'Terra + terrain' },
] as const;

export function defaultImageRecipe(unitSystem: UnitSystem): RouteImageRecipe {
  return { treatment: 'terra-terrain', rotation: 0, tilt: 45, terrainHeight: 1.15, unitSystem };
}

export function imageFilename(ride: Ride, treatment: RouteImageTreatment): string {
  const suffix: Record<RouteImageTreatment, string> = { 'terra-terrain': 'TerraTerrain' };
  return `${filenamePart(ride.title, 100) || 'Ride'}_${suffix[treatment]}.png`;
}
